import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import { makeAutoObservable } from 'mobx'
import type { Academy, Teacher, User } from '@/dto'
import { UserPermission } from '@/models/(Permission)/UserPermission'
import { CustomRouterStore } from '@/router/CustomRouterStore'

class CommonRepo {
  teacherId?: Teacher['teacherId'] // 사용하지 않는 것으로 보이나 앱 등도 확인이 필요해서 일단 유지
  user?: User
  permission = new UserPermission({
    userAuthority: 'MANAGER_TEACHER',
    academyFeatureAuthority: 'BASIC',
    subscribedCurriculums: null,
    payStatus: '무료체험',
    isLimited: !!localStorage.getItem('PERSIST_LIMITED'),
    isSeoltab: false,
    isFranchise: false,
  })
  academy?: Academy
  router = new CustomRouterStore()
  version = '' // 안드로이드 등 디바이스 버전
  device = '' //  디바이스

  hasWorksheet = false

  constructor() {
    makeAutoObservable(this)
  }

  clear() {
    this.academy = this.teacherId = this.user = undefined
  }

  get isSolo() {
    return this.permission.byFeature.isSolo
  }

  get isSeoltab() {
    return false
  }

  // window.location.host랑 다른 값
  get host() {
    return `${domainProvider.TARGET_DOMAIN}`
  }

  get appName() {
    return 'mathflat'
  }

  get appKorName() {
    return '사이언스플랫'
  }

  get agencyNameInKor() {
    return '학원'
  }

  get isFranchise() {
    return this.academy?.isFranchise ?? false
  }

  // 현재 미사용
  get isElectronApp() {
    return window.bridge !== undefined
  }

  /**
   * @deprecated
   * TODO: 저작권 이슈 - 임시 코드. 제거 기한 미정
   */
  get isLimited() {
    return this.permission.isLimited
  }

  get 임시제한() {
    const TARGET_DCODE = ['D55635', 'D29601']
    const dCode = this.academy?.academyId ?? ''
    if (TARGET_DCODE.includes(dCode)) {
      return true
    }

    return this.isLimited
  }
}

const commonRepo = new CommonRepo()
export default commonRepo
